import { Col, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Dispatch, SetStateAction } from 'react';

import { FormFilter, InputForm } from 'components';
import Content from 'layouts/Content';

interface IJobTitle {
  id: string;
  jobName: string;
  role: string;
}
interface IProps {
  open: boolean;
  dataOption: IJobTitle[];
  onFinish: (values: any) => void;
  setIsOpenFilter: Dispatch<SetStateAction<boolean>>;
  setValueFilter: Dispatch<SetStateAction<any>>;
}

const spanCol = 12;

const FilterUpdateRole = ({ open, onFinish, setValueFilter }: IProps) => {
  const [form] = useForm();
  // const [idOptions, setidOptions] = useState<DefaultOptionType[]>();
  // const [nameOptions, setnameOptions] = useState<DefaultOptionType[]>();
  // const [roleOptions, setroleOptions] = useState<DefaultOptionType[]>();

  // const { mutate: getAllJobTitle } = useMutation({
  //   mutationFn: () => RoleJobTitleApis.getAllRoleCombobox(),
  //   onSuccess: (res) => {
  //     setRoleOptions(
  //       res.data.getRole.items
  //         ? res.data.getRole.items.map((item: any) => ({
  //             value: item.id,
  //             label: item.id,
  //           }))
  //         : [],
  //     );
  //   },
  //   onError: (error) => {
  //     console.log(error);
  //   },
  // });

  // useEffect(() => {
  //   // const idOptions = dataOption.map((role) => ({
  //   //   label: role?.id,
  //   //   value: role?.id,
  //   // }));
  //   // setidOptions(idOptions);

  //   const nameOptions = dataOption.map((role) => ({
  //     label: role.id + ' - ' + role?.jobName,
  //     value: role?.id,
  //     key: role.id,
  //   }));
  //   setnameOptions(nameOptions);

  //   const roleOptions = dataRole.map((role) => ({
  //     label: role?.id,
  //     // label: role?.id + '-' + role?.name,
  //     value: role?.id,
  //     key: role.id,
  //   }));
  //   setroleOptions(roleOptions);
  //   // getAllJobTitle();
  // }, [dataOption]);

  const onCancel = () => {
    form.resetFields();
    setValueFilter({});
  };

  return (
    <Content isOpen={open}>
      <FormFilter form={form} onFinish={onFinish} onCancel={onCancel}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {/* <Col span={spanCol} className="h-[80px]">
            <Form.Item name={'id'} label="Mã chức vụ">
              <InputForm placeholder="Nhập mã chức vụ" />
            </Form.Item>
          </Col> */}
          <Col span={spanCol} className="h-[80px]">
            <Form.Item name={'jobName'} label="Chức vụ">
              <InputForm placeholder="Nhập tên chức vụ" />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item name="role" label="Quyền">
              <InputForm placeholder="Nhập quyền" />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterUpdateRole;
